import { useContext } from 'react';
import { Breadcrumb } from 'dash-ui';
import { useNavigate } from 'react-router-dom';

import { BreadcrumbContext } from 'common/contexts/breadcrumb-context/breadcrumb-context';
import { BulkActionsContext } from 'common/contexts/bulkActionsContext/bulkActionsContext';

function BreadcrumbNavigation() {
  const navigate = useNavigate();
  const { breadcrumbItems } = useContext(BreadcrumbContext);
  const { resetState } = useContext(BulkActionsContext);

  return (
    <Breadcrumb
      limit={7}
      onNavigate={(route) => {
        resetState();
        navigate(route);
      }}
      items={breadcrumbItems}
    />
  );
}

export default BreadcrumbNavigation;
